import graphql__acb11b08416a8d31f05f from "./__generated__/UserAvatar_user.graphql.js";import { useState, useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import initials from "../Utils/initials";

const INITIALS_BASE_FONT_SIZE_REM = 1.5;
const USER_AVATAR_DEFAULT_SIZE = 50;

const UserAvatarImage = props => {
  const className = classNames(["user-avatar", props.className]);
  const style = {
    display: "inline-block",
    backgroundImage: `url(${props.avatarUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    width: props.size,
    height: props.size
  };

  return <span className={className} style={style} />;
};

const UserAvatarNoImage = props => {
  const { size } = props;

  const className = classNames([
    "user-avatar-initials",
    "d-flex",
    "align-items-center",
    "justify-content-center",
    "rounded-circle",
    "text-uppercase",
    "text-sign-sm",
    props.className,
    {
      "bg-primary": !props.inverse,
      "bg-primary-inverse": props.inverse
    }
  ]);

  const style = {
    width: size,
    height: size,
    fontSize: `${INITIALS_BASE_FONT_SIZE_REM * (size / USER_AVATAR_DEFAULT_SIZE)}rem`
  };

  return (
    <span className={className} style={style}>
      {initials(props.name)}
    </span>
  );
};

// Allow displaying the UserAvatar component without providing a relay fragment to
// display the component.
//
export const UserAvatarWithoutRelay = ({ size = USER_AVATAR_DEFAULT_SIZE, ...props }) => {
  const { avatarUrl } = props.user;
  const name = props.name || props.user.name;
  const { className, inverse } = props;

  const [hasImage, setHasImage] = useState(Boolean(avatarUrl));

  // Try to load the avatar image, and if the avatar can't be loaded, fallback to the
  // initials, to avoid having a blank image that doesn't indicate the user that there's
  // a button there to click on.
  useEffect(() => {
    if (!avatarUrl) return;

    const image = new Image();
    // If the image can't be loaded, fallback to the initials.
    image.onerror = () => setHasImage(false);
    // This allows for displaying the image when the user didn't have an avatar and adds
    // one in their profile.
    image.onload = () => setHasImage(true);
    // Load the image : note that it won't be loaded twice (from the DOM and here) as the
    // browser caches the image and only requests it once, but calls the callbacks even
    // if the image is already in cache.
    image.src = avatarUrl;
  }, [avatarUrl, hasImage]);

  if (hasImage && avatarUrl) {
    return <UserAvatarImage {...{ avatarUrl, className, size }} />;
  } else {
    return <UserAvatarNoImage {...{ name, inverse, className, size }} />;
  }
};

// This component is a wrapper around the UserAvatarWithoutRelay component and defines
// the needed relay fragment for its underlying wrapped component, allowing the sub
// component to be used without Relay
//
const UserAvatar = props => {
  const user = useFragment(UserAvatar_user, props.user);

  return <UserAvatarWithoutRelay {...props} user={user} />;
};

const UserAvatar_user = graphql__acb11b08416a8d31f05f;

export default UserAvatar;
